import React, { FC, useEffect, useState } from "react";
import { navigate } from "gatsby-link";
import CaruselComponent from "../automation-card-carusel";
import Button from "../button";
import { GET_AUTOMATIONS } from "../../graphql/queries";
import { useQuery } from "@apollo/react-hooks";
import "./styles.scss";

interface IAutomationsCarusel {
  title: string;
  subtitle: string;
  subtitle2: string;
  typeId?: number;
  href?: string;
  className?: string;
}
const AutomationsCarusel: FC<IAutomationsCarusel> = ({
  title,
  subtitle,
  subtitle2,
  typeId,
  href,
  className,
}) => {
  const [automationArr, setAutomationArr] = useState([] as any);

  const { data, loading } = useQuery(GET_AUTOMATIONS, {
    variables: {
      settings: {
        filter: typeId
          ? {
              automation_kind: { automation_type_id: typeId && typeId },
            }
          : {},
      },
    },
  });

  useEffect(() => {
    if (data?.HexomaticAutomation?.getAutomationsPublic?.automations) {
      setAutomationArr(
        data?.HexomaticAutomation?.getAutomationsPublic?.automations
      );
    }
  }, [data]);
  return (
    <div className="row mt-5 carusel-component">
      <div className="col-12">
        <h2 className=" f_size_26 f_700 t_color3 l_height45 mt_20 mb-20 text-center">
          {title}
        </h2>

        <p className="text-center">{subtitle}</p>

        <p className="text-center justify-content-center align-itmems-center">
          {subtitle2}
        </p>
      </div>

      <div className="col-12 my-4 carusel-wrapper">
        <CaruselComponent
          loading={loading}
          lists={automationArr}
          className={className}
        />
      </div>
      <div className="col-12 text-center">
        <Button
          primary
          onClick={() => navigate(href ? href : "/automations")}
          className="mb-0"
        >
          {href
            ? "Click to show the next automations"
            : "Browse all automations"}
        </Button>
      </div>
    </div>
  );
};

export default AutomationsCarusel;
